import { Box, Typography } from "@mui/material";
import { ExpandMore, HelpOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";
import { getGradeColor } from "../../Helpers/gradeHelpers";

export interface SectionHeaderProps {
  grade: number;
  title: string;
  gradeDescription: string;
  hasQuestions: boolean;
  isExpanded: boolean;
  onToggle: () => void;
}

export function SectionHeader({
  grade,
  title,
  gradeDescription,
  hasQuestions,
  isExpanded,
  onToggle,
}: SectionHeaderProps) {
  const { t } = useTranslation("singleCompanyComponent");
  const { colors: workspace } = useWorkspaceColors();
  const roundedGrade = Math.round(grade);
  return (
    <Box
      onClick={onToggle}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2.5,
        py: 2,
        bgcolor: "white",
        cursor: "pointer",
        borderLeft: "4px solid transparent",
        "&:hover": {
          bgcolor: `${workspace.primary_dark}0F`,
          borderLeftColor: workspace.accent,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 48,
            height: 48,
            fontSize: "1.125rem",
            fontWeight: 600,
            borderRadius: 1,
            border: "1px solid",
            ...getGradeColor(grade),
          }}
        >
          {roundedGrade}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: colors.gray900 }}
            >
              {title}
            </Typography>
            {hasQuestions && (
              <HelpOutline
                sx={{
                  color: colors.orange500,
                  fontSize: "1.2rem",
                }}
              />
            )}
          </Box>
          <Typography variant="caption" sx={{ color: colors.gray600 }}>
            {t(gradeDescription)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ExpandMore
          sx={{
            color: colors.gray500,
            transform: isExpanded ? "rotate(180deg)" : "none",
            transition: "transform 0.2s",
          }}
        />
      </Box>
    </Box>
  );
}
